import { QueryClient, QueryClientProvider } from 'react-query';
import { MsalProvider } from '@azure/msal-react';
import { getDynamicComponents } from 'components';
import ErrorBoundary from 'components/esadir/ErrorBoundary';
import ServicesProvider from 'context/ServicesProvider';
import ViewportProvider from 'context/corporatiu/ViewportProvider';
import styles from '../../../web/styles/esadir/globals.module.scss';
import PublicitatProvider from 'context/PublicitatProvider';
import { UserProvider, myMSALObj } from 'context/UserProvider';
import { useState } from 'react';
const DynamicComponents = getDynamicComponents('esadir');

const Appesadir = ({ Component, pageProps }) => {
    const [queryClient] = useState(() => new QueryClient());

    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <MsalProvider instance={myMSALObj}>
                    <ServicesProvider>
                        <UserProvider>
                            <PublicitatProvider>
                                <ViewportProvider {...pageProps}>
                                    <div id='__mainContent' className={styles.esadir}>
                                        <Component {...pageProps} dynamicComponents={DynamicComponents} />
                                    </div>
                                    <div id='app-modal' className={`${styles.esadir} ${styles.appModal}`} />
                                </ViewportProvider>
                            </PublicitatProvider>
                        </UserProvider>
                    </ServicesProvider>
                </MsalProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    );
};

export default Appesadir;
